import { render } from "./InstructionsForUse.vue?vue&type=template&id=5b65c23a&scoped=true"
import script from "./InstructionsForUse.vue?vue&type=script&lang=js"
export * from "./InstructionsForUse.vue?vue&type=script&lang=js"

import "./InstructionsForUse.vue?vue&type=style&index=0&id=5b65c23a&lang=less&scoped=true"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b65c23a"]])

export default __exports__